import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface IOffersFilter {
  search?: string;
  selected_cities_id?: string;
  input_guid: IInputGroupsFilter[];
  advertisement_type?: string;
  order_by: string;
  has_store: boolean;
  has_price: boolean;
  start_price: number;
  end_price: number;
}

export interface ISerach {
  search: string;
}

export interface IInputGroupsFilter {
  guid: string;
  title: string;
}

const initialState: IOffersFilter = {
  search: '',
  input_guid: [],
  selected_cities_id: '',
  advertisement_type: '',
  order_by: '',
  has_store: false,
  has_price: false,
  start_price: 0,
  end_price: 999000000,
};

export const offersSlice = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    findOffers: (state, action: PayloadAction<IOffersFilter>) => {
      state.selected_cities_id = action.payload.selected_cities_id;
      state.advertisement_type = action.payload.advertisement_type;
      state.order_by = action.payload.order_by;
      state.has_store = action.payload.has_store;
      state.has_price = action.payload.has_price;
      state.start_price = action.payload.start_price;
      state.end_price = action.payload.end_price;
      state.input_guid = action.payload.input_guid;
    },
    findOffersBySearch: (state, action: PayloadAction<ISerach>) => {
      state.search = action.payload.search;
    },
    clearOffersList: state => {
      state.advertisement_type = '';
      state.order_by = '';
      state.has_store = false;
      state.selected_cities_id = '';
      state.has_price = false;
      state.start_price = 0;
      state.end_price = 999000000;
      state.input_guid = [];
    },
  },
});

export const {findOffers, findOffersBySearch, clearOffersList} =
  offersSlice.actions;

export default offersSlice.reducer;
